import { gql } from "@apollo/client";

export const GET_PROPERTY_VISNINGSPAAMELDING_QUERY = gql`
  query GetPropertyVisningspaamelding($input: PropertyInput) {
    getProperty(input: $input) {
      wmId
      id
      type
      assignmentType
      address
      hovedoppdrag
      hovedoppdragId {
        id
      }
      price {
        info {
          price
        }
      }
      checklistpoints {
        info {
          event
        }
      }
    }
  }
`;
